import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'

@Pipe({
  name: 'translation',
  standalone: true,
})
export class TranslationPipe implements PipeTransform {
  constructor(private sanitized?: DomSanitizer) { }
  transform(value: string, ...args: unknown[]): any {
    let lang = localStorage.getItem("lang") ?? location?.pathname?.split("/")[1];
    let translations = lang && localStorage.getItem("dictionary_"+lang?.toUpperCase()) ?JSON.parse(localStorage.getItem("dictionary_"+lang?.toUpperCase())??""):{};
    return value === "label.profiledeleted"? `${translations[value].replace('${childFirstName}','{{this.profile.firstName}}')}`:translations[value] ??  "";
  }

}
